import { BASE_CURRENCY } from '@/constants/shop'

export type Rates = Record<string, number>

const SYMBOLS: Record<string, string> = {
    ZAR: 'R',
    USD: '$',
    EUR: '€',
    GBP: '£',
    CAD: 'CA$',
    AUD: 'A$'
}

/** Converts an amount in rand into another currency. Falls back to rand when no rate is known. */
export const convert = (amountZar: number, currency: string, rates: Rates | null): { amount: number, currency: string } => {
    if (currency === BASE_CURRENCY) return { amount: amountZar, currency: BASE_CURRENCY }

    const rate = rates?.[currency]

    if (!rate) return { amount: amountZar, currency: BASE_CURRENCY }

    return { amount: amountZar * rate, currency }
}

const group = (whole: number, separator: string): string =>
    String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, separator)

/** Deterministic formatting, so the server and the browser always render the same text. */
export const formatMoney = (amount: number, currency: string): string => {
    const symbol = SYMBOLS[currency] ?? `${currency} `
    const rounded = Math.round(amount * 100) / 100
    const whole = Math.floor(Math.abs(rounded))
    const cents = Math.round((Math.abs(rounded) - whole) * 100)
    const separator = currency === BASE_CURRENCY ? ' ' : ','
    const sign = rounded < 0 ? '-' : ''
    const decimals = currency === BASE_CURRENCY && cents === 0 ? '' : `.${String(cents).padStart(2, '0')}`

    return `${sign}${symbol}${group(whole, separator)}${decimals}`
}

/** Rand to cents, the unit the payment provider expects. */
export const toCents = (amountZar: number): number => Math.round(amountZar * 100)
